import type {ReadonlyDeep} from 'type-fest';
import {UNCHANGED_PASSWORD} from '@netx/core-auth-next/constants';
import {UserLevel} from './constants';
import {UserSource} from './schema';
import type {UserSelector, IUser, IUserNew} from './types';

export const userSelectorDefaults: ReadonlyDeep<UserSelector> = {
	all: false,
	emails: [],
	groupIds: [],
	none: false,
	userIds: [],
};

// TODO: Lock down typing
export const userDefaults: Readonly<IUser> = {
	address1: '',
	address2: '',
	city: '',
	country: '',
	email: '',
	expirationDate: '',
	groupIds: [],
	groupNames: [],
	login: '',
	name1: '',
	name2: '',
	name3: '',
	name4: '',
	notify: 1,
	organization: '',
	password1: '',
	password2: '',
	phone1: '',
	phone2: '',
	phone3: '',
	phone4: '',
	propertyNames: [],
	propertyValues: [],
	state: '',
	type: UserLevel.BROWSER,
	userId: 0,
	userSource: UserSource.INTERNAL,
	zip: '',
	appPermissions: [],
	disabled: false,
	loginDate: '',
	isLoggedIn: false,
	canCreateAPITokens: false,
};

export const newUserDefaults: IUserNew = {
	...userDefaults,
	password1: UNCHANGED_PASSWORD,
	password2: UNCHANGED_PASSWORD,
};
